import { SET_AGENDA_BY_DEFAULT } from './types';

export function setAgendaSelectedByDefault(value: boolean) {
  return {
    type: SET_AGENDA_BY_DEFAULT,
    payload: value,
  };
}
